import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { SimpleInputProps } from 'types/SimpleInputProps';
import QuestionBox from 'components/QuestionBox';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';

export default function SimpleInput({
	label = 'simpleInput.passLabel',
	withoutLabel = false, // se true fica sem a label
	typeInput = 'text',
	placeHolder = '',
	getValue = function (value: any) {
		return value;
	},
	error = false,
	messagemError = 'simpleInput.anyError',
	initialValue = '',
	styleInput = {},
	maxLength = 255,
	countLength = false,
	autoComplete = 'on',
	disable = false,
	onPressEnter = () => {},
	messageQuestionBox = '',
	useBtnInput = false,
	textUseBtnInput = 'Passe um nome',
	functionUseBtnInput = () => {},
	colorTxtUseBtnInput = color.interface.white,
	backgroundColorTxtUseBtnInput = color.system.info,
	paddingInLineEnd = false,
	...rest
}: SimpleInputProps) {
	const { t }: UseTranslationProps = useTranslation();
	const inputRef = React.useRef<HTMLInputElement>(null);
	return (
		<S.inputBox style={{ ...styleInput }} isdisable={disable}>
			<S.labelAndQuestionBox>
				{!withoutLabel && <p>{t(label)}</p>}
				{messageQuestionBox !== '' && (
					<QuestionBox text={t(messageQuestionBox)} width={2} />
				)}
			</S.labelAndQuestionBox>

			<S.inputAndBtn $paddingInLineEnd={paddingInLineEnd}>
				<input
					{...rest}
					ref={inputRef}
					type={typeInput}
					placeholder={placeHolder}
					onChange={(event) => getValue(event.target.value)}
					value={initialValue}
					maxLength={maxLength}
					// onFocus={(event) => {
					// 	if (typeInput.includes('date') && event?.target?.showPicker) {
					// 		// Simula clique para abrir o calendário
					// 		event?.target?.showPicker();
					// 	}
					// }}
					autoComplete={autoComplete}
					disabled={disable}
					data-testid={rest.id || label}
					onKeyDown={(value) => {
						if (typeInput.includes('date') && inputRef.current?.showPicker) {
							value.preventDefault(); // ❌ Bloqueia digitação
							// Simula clique para abrir o calendário
							inputRef.current?.showPicker?.(); // ✅ Para navegadores modernos
							inputRef.current?.click(); // Fallback
						}
						if (value.key === 'Enter') {
							onPressEnter();
						}
					}}
				/>

				{useBtnInput && (
					<button
						style={{
							color: colorTxtUseBtnInput,
							backgroundColor: backgroundColorTxtUseBtnInput
						}}
						onClick={functionUseBtnInput}
					>
						{textUseBtnInput}
					</button>
				)}
			</S.inputAndBtn>

			{(error || countLength) && (
				<S.messages>
					{error && <S.errorMessage>{t(messagemError)}</S.errorMessage>}
					{!error && countLength ? (
						<S.containerContLength>
							<p>
								{initialValue.length} {t('simpleInput.of')} {maxLength}
							</p>
						</S.containerContLength>
					) : undefined}
				</S.messages>
			)}
		</S.inputBox>
	);
}
